import PropTypes from 'prop-types'
import NotificationMediaPropTypes from './NotificationMediaPropTypes'

const NotificationPropTypes = {
  placeLogo: PropTypes.string,
  placeName: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.string,
  description: PropTypes.string,
  priority: PropTypes.string.isRequired, // 2 types: {information,important}
  media: PropTypes.oneOfType([
    PropTypes.shape(NotificationMediaPropTypes),
    PropTypes.bool,
  ]),
}

export default NotificationPropTypes
